<template>
    <div>
        <div ref="printPdf">
            <div style="margin-bottom: 20px;">
                <div style="display: flex; justify-content: space-between;">
                    <div>
                        <p style="font-size: 18px; font-weight: bold; margin: 0; color: #333;">
                            Enrollment Agreement <strong>(Revision Date:</strong> 01/09/2026)
                        </p>
                    </div>
                    <div style="flex-shrink: 0;">
                        <img
                            src="../../../assets/img/BAU_Logo.png"
                            :alt="$t('agreement_form_title')"
                            style="height: 60px; width: auto;"
                            ref="logoImage"
                        />
                    </div>
             </div>
                <div class="mb-3 mt-3">
                    <strong class="text-sm text-md-md text-lg-lg">
                        BY CLICKING THE BOX AT THE END OF THIS DOCUMENT INDICATING YOUR ACCEPTANCE (THE "ACCEPTANCE") OF THIS ENROLLMENT CONTRACT (THIS "AGREEMENT"), YOU AGREE YOU HAVE READ AND ARE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE WITH THIS AGREEMENT, YOU MUST NOT ACCEPT THIS AGREEMENT AND MUST NOT CONTINUE WITH THE COURSE REGISTRATION. DOING SO MEANS YOU START AN OFFICIAL WITHDRAWAL PROCESS. IF YOU ACCEPT THIS AGREEMENT, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD, AND ARE BOUND BY, THE TERMS AND CONDITIONS STATED HEREIN.
                    </strong>
                </div>
                <div class="mb-4">
                    <p>This Agreement is by and between you and BAY ATLANTIC UNIVERSITY (the "BAU") and is
                        effective as of the date of Acceptance (the "Effective Date"). It governs your academic and
                        financial rights and responsibilities as a student in the Mentora College ESL Program. BAU
                        reserves the right to change or modify portions of this Agreement at any time. You will be
                        asked to sign the Agreement for each module you are enrolled at BAU in the Mentora College
                        ESL Program.</p>
                    <strong class="text-sm text-md-md text-lg-lg">
                        This Agreement Covers the Following Current Period of Attendance for the Program:
                        Period of Attendance Start Date: {{ registrationForm.active_module_start_date }} Period of Attendance End Date: {{ registrationForm.active_module_end_date }}

                    </strong>
                    <p>
                        This Agreement covers only the above-referenced current period of attendance for the Program. If the
                        courses necessary to complete the Program extend beyond the above-referenced "Period of
                        attendance end date", as a condition to further enrollment, you will be required to execute a new
                        Enrollment Agreement with BAU's Mentora College ESL Program to cover the remaining attendance
                        period. </p>
                </div>
                <div>
                    <p><b>A. VERIFICATION OF PERSONAL INFORMATION</b></p>
                    <p>The following information is pulled from the application form you submitted.</p>
                </div>
            <!-- Personal Information -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">{{ $t('Your Personal Information') }}</h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                    <tbody>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Name :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.name ? registrationForm.name : '' }} {{ registrationForm.surname ? registrationForm.surname : '' }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Middle Name :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.middle_name ? registrationForm.middle_name : '' }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Date Of Birth :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.birthdate ? toLocaleDate(registrationForm.birthdate) : '' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

                <!-- Your Mailing US Address -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">
                {{ $t('your_mailing_us_address') }}
            </h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                    <tbody>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Address :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.contact_address ? registrationForm.contact_address : '' }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">State :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.contact_state_name ? registrationForm.contact_state_name : '' }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">City :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.contact_city_name ? registrationForm.contact_city_name : '' }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Apartment :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.apartment ? registrationForm.apartment : '' }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Zip Code :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.contact_zip_code ? registrationForm.contact_zip_code : '' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Your Home Address -->
             <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Your Home Address</h4>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                     <tbody>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Country :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.address_country_name ? registrationForm.address_country_name : '' }}
                             </td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Address :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.address ? registrationForm.address : '' }}
                             </td>
                         </tr>
                     </tbody>
                 </table>
             </div>

            <!-- Contact Information -->
             <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Contact Information</h4>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                     <tbody>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Email :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.personal_email ? registrationForm.personal_email : '' }}
                             </td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Mobile Number :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.mobile_tel ? ((registrationForm.mobile_tel_country_code??'') + registrationForm.mobile_tel) : '' }}
                             </td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Other Phone :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.home_tel ? (registrationForm.home_tel_country_code??'') + '' + registrationForm.home_tel : '' }}
                             </td>
                         </tr>
                     </tbody>
                 </table>
             </div>

            <!-- Emergency Contact Information -->
             <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Emergency Contact Information</h4>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                     <tbody>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Name :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.emergency_person_name ? registrationForm.emergency_person_name : '' }}
                             </td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Relationship :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.emergency_person_relation ? registrationForm.emergency_person_relation : '' }}
                             </td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Phone :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.emergency_person_phone ? (registrationForm.emergency_person_phone_country_code??'') + registrationForm.emergency_person_phone : '' }}
                             </td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Legal Status :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                 {{ registrationForm.legal_presence_type ? registrationForm.legal_presence_type : '' }}
                             </td>
                         </tr>
                     </tbody>
                 </table>
                 </div>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse;">
                     <tbody>
                         <tr>
                             <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                 I confirm that the information given in this form is true, complete and accurate
                             </td>
                             <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                 <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                             </td>
                         </tr>
                     </tbody>
                 </table>
             </div>

            <!-- Program Information -->
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">B. PROGRAM INFORMATION</h4>
            <div style="margin-bottom: 20px;">
                <p>
                    The following information is from the application form you submitted.
                </p>
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                    <tbody>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Program Of Study :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.program_name ? registrationForm.program_name : null }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Program Start Date :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.registration_date ? registrationForm.registration_date : null }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Registration Type :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ registrationForm.registration_type_text ? registrationForm.registration_type_text : null }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Enrollment Status :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                {{ studentData.student_status_text ? studentData.student_status_text : null }}
                            </td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Initial CEFR Level :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                <span v-if="registrationForm.cefr_credit && registrationForm.credit">{{ registrationForm.cefr_credit ? registrationForm.cefr_credit : '' }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                        <tr>
                            <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                I read and confirm that I understand the information in Section B.
                            </td>
                            <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            <!-- Tuition and Fees -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">C. FEES AND CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE</h4>

            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
                    <tbody>
                        <tr v-for="(menu, j) in data" :key="j" style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">{{ menu.key }} :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">
                                <span v-html="menu.value"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div style="margin-top: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I read and confirm that I understand the information in Section C.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Scholarship/Tuition Assistance -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">D. SCHOLARSHIPS/TUITION ASSISTANCE/AWARDS.</h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-bottom: 15px;">
                    <tbody>
                        <tr v-for="(menu, j) in scholarshipData" :key="j" style="border-bottom: 1px solid #eee;">
                            <td style="padding: 12px;  width: 40%;">{{ menu.key }}</td>
                            <td style="padding: 12px; color: #555; white-space: pre-line;">{{ menu.value }}</td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <p>*Students who earn a scholarship/tuition discount/award of any category should meet the
                        following criteria to maintain the award:
                        <br>
                        1)	Continuously enroll in courses each module (unless taking approved time off)
                        and
                        <br>
                        2)	Maintain a minimum attendance rate of 80% for any Module and
                        <br>
                        3)	Avoid any disciplinary action for any reason. <br>
                        Scholarships, tuition discounts and/or awards are available for students who qualify. That is
                        why continuing your studies at BAU in the Mentora ESL Program is essential, as another
                        student might have been rejected at the time of your application.
                        Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from
                        the Mentora ESL Program and does not transfer into the BAU degree program, they will not
                        receive a refund of the deposit, and/or may be required to repay the scholarship or tuition discounts received for the modules attended, according to the terms and conditions of their promotion, and/or pay an Administrative Service Fee. BAU Mentora ESL Program is committed to re-use these funds for
                        students who need or earn financial assistance. If a new student wishes to transfer their SEVIS record to another institution prior to or during the initial session (3 modules), BAU will not refund any portion of their tuition deposit or fees. Additionally, the student will be required to pay an Administrative Service Fee of $1,650.
                    </p>
                </div>
                <div style="margin-top: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I read and confirm that I understand the information in Section D.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <!-- Cancellation Refund Policy -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">E. Time-Off and Transferring Out</h4>
           <div>
               <p>
                   This policy outlines guidelines for taking time off while maintaining F1 status. It ensures that students comply with federal and school regulations regarding enrollment and authorized breaks, balancing academic responsibilities with personal needs.
               </p>
               <div>
                   <p><strong>Time Off Eligibility</strong></p>
                   <p>
                       To comply with U.S. SEVIS regulations, F-1 students are eligible to take up to one full session (three modules) of authorized Time Off per calendar year (12 months). Due to Mentora ESL course models and SEVIS regulations, students are not permitted to take Time Off in the middle of a session. Students should also note that Time Off is NOT cumulative.
                   </p>
                   <p><strong>1. First Time Off Period</strong></p>
                   <p>
                       F-1 students become eligible for their first Time Off period after successfully completing six (6) consecutive academic modules, equivalent to two (2) full academic sessions. Once eligible, Time Off must be taken in the next immediately consecutive module or session, and students may choose one of the following options:
                   </p>
                   <ul>
                       <li>Take one (1) module of Time Off, which must be Module 1 of the next session, or</li>
                       <li>Take one full session (three consecutive modules) of Time Off, beginning with Module 1 of the next session.</li>
                   </ul>
                   <p>
                       Students may not complete one or more modules of a session and then begin Time Off later within that same session.
                   </p>

                   <p><strong>2. Subsequent Time Off Periods</strong></p>
                   <p>
                       After returning from their first approved Time Off period, students may become eligible for additional Time Off after completing the required three (3) or six (6) consecutive study modules, as applicable. Time Off must be taken in the next immediately consecutive module or session, and students may choose one of the following options:
                   </p>
                   <ul>
                       <li>Take one (1) module of Time Off, after completing three (3) consecutive study modules. The Time Off must be taken as Module 1 of the next session, or</li>
                       <li>Take one full session (three consecutive modules) of Time Off, after completing six (6) consecutive study modules. The Time Off must begin with Module 1 of the next session.</li>
                   </ul>
                   <p>
                       All Time Off periods remain subject to a maximum of three (3) Time Off modules within any 12-month period.
                   </p>

                   <p><strong>Student Standing Requirement</strong></p>
                   <p>To be eligible for Time Off, students must be in good standing, which includes:</p>
                   <ul>
                       <li>Good academic standing</li>
                       <li>Good attendance</li>
                       <li>Good financial standing</li>
                   </ul>

                   <p><strong>Important Notes</strong></p>
                   <ul>
                       <li>Time Off eligibility is based on continuous enrollment and successful academic progress.</li>
                       <li>All Time Off requests are subject to administrative review and approval.</li>
                       <li>Students are encouraged to plan their Time Off periods carefully to maintain F-1 status compliance.</li>
                       <li>For the purposes of this policy, “consecutive modules” refer to modules completed in uninterrupted academic sessions, excluding any module during which the student was on a medically excused absence or had an approved reduced course load.</li>
                   </ul>

                   <p><strong>Deadlines for Time Off request.</strong></p>
                   <p>
                       All students must submit all required documents for Time Off before the deadline of the current class module they are attending (See Handbook Section 5).
                   </p>

                   <p><strong>Time-Off Fee</strong></p>
                   <p>
                       The Time-Off Fee is calculated as 50% of the tuition for each module taken as Time Off, plus the tuition deposit for one (1) module, which must be paid in advance.
                       The deposit will be credited toward tuition when the student returns from their approved Time Off period.
                   </p>
               </div>
               <p>
                   <strong>Transferring Out (F-1 Students)</strong>
               </p>
               <p>
                   As an F-1 student, you may transfer to another institution
                   in the U.S. if you wish to continue your studies at a different institution.
                   However, there are specific eligibility requirements and procedures that must be followed to ensure your transfer is compliant with both school and federal regulations. This section outlines the steps you need to take.

               </p>
               <p>
                   <strong>Required documents</strong>
               </p>
               <p>
                   Students requesting a Transfer Out must submit their request through their MyBAU student account by completing the Transfer Out Request section. Students are required to complete all requested personal information and upload the required supporting documentation directly within the system:
               </p>
               <ul>
                   <li>A completed Transfer Out Request submitted through MyBAU</li>
                   <li>An official acceptance letter from the new institution</li>
                   <li>A Transfer Out Verification Form from the new institution (if applicable)</li>
               </ul>
               <p>
                   All required documents must be uploaded at the time of submission. Incomplete or late submissions may delay processing and may be subject to a Late Document Processing Fee. For more information, see the Deadline for Transferring Out section.
               </p>
               <p><strong>Deadlines for Transferring out.</strong></p>
               <p>
                   All students must submit all required documents for Transferring out before the deadline of the current class module they are attending (See Handbook Section 5).
               </p>
               <p>
                   No exceptions will be made. If a student misses the deadline the student is required to:
               </p>
               <ul>
                   <li>Register and complete one additional class module or</li>
                   <li>Complete a “Late Document Processing Fee” equal to $640.</li>
               </ul>
               <p>
                   This Late Document Processing Fee may apply to all students who submit required documents or complete administrative processes after the stated deadlines. This fee accounts for the additional time and resources required to manually handle and reconcile late submissions outside of the standard processing timeline. Timely compliance with deadlines helps the university serve all students more efficiently and fairly.
               </p>

               <p><strong>Transferring out before completing first session (first 3 modules)</strong></p>
               <p>
                   All new students must study their first session (first 3 modules) to be eligible to transfer out. If a student is willing to transfer before completing their first session the student must complete all transfer out documents and pay the “Administrative Services Fee”. This fee reflects the administrative time and resources required to process early withdrawals, including coordination with internal departments and external institutions. Completing at least one full session ensures smoother transitions and helps maintain the integrity of academic and administrative planning.
               </p>

               <p><strong>Transferring out after Time off.</strong></p>
               <p>
                   All students who return from time off must register and complete one full session (3 modules) before they are eligible to transfer in active status to another institution. If a student decides not to register or to withdraw before completing all 3 modules, they must pay an “Administrative Services Fee”, complete all required documents and follow all transfer out steps. This fee reflects the administrative time and resources required to process early withdrawals, including coordination with internal departments and external institutions. Completing at least one full session ensures smoother transitions and helps maintain the integrity of academic and administrative planning.
               </p>
               <p>
                   To be eligible to transfer to another institution, you must meet the following requirements:
               </p>
               <ol>
                   <li>
                       Complete your initial session (first 3 modules) in the Mentora College ESL Program.
                   </li>
                   <li>
                       Be in good standing, which means you must have:
                       <ul>
                           <li>Good Academic Standing</li>
                           <li>Good Attendance</li>
                           <li>Good Financial Standing</li>
                           <li>No types of probation</li>
                       </ul>
                   </li>
                   <li>
                       Not be in a Time Off period (you must be actively enrolled in classes).
                   </li>
                   <li>
                       Maintain your F-1 status (If applicable):
                       <ul>
                           <li>You must follow all school and federal regulations.</li>
                           <li>You must continue attending classes until your transfer release date.</li>
                           <li>If you don’t maintain your F-1 status or fail to follow proper procedures, you may lose eligibility to transfer in Active status.</li>
                       </ul>
                   </li>
               </ol>
               <p>
                   If the student wishes to transfer their SEVIS record to another institution prior to completing a session (3 Modules) after Time-Off, BAU Mentora ESL Program will not refund any portion of their tuition deposit or fees and the student will be required to pay an Administrative Service Fee.
                   (See section 5.2.1 to 5.2.5 of the Mentora ESL Handbook for detailed information).
               </p>



                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I read and confirm that I understand the information in Section E.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            </div>

            <div style="margin-bottom: 20px;">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">F. FINANCIAL GOOD STANDING</h4>
                <p>
                           Financial good standing and a university record clear of holds are required for students to
                                receive services. Upon course registration, students are required to sign a Financial
                                Responsibility Agreement that outlines all financial procedures, obligations, rights, and
                                responsibilities that are summarized below:
                                Services, including but not limited to access to courses, transcript issuance, diploma release,
                                class registration (add, drop, withdrawal, etc.), and/or housing, will be immediately suspended
                                for students with a financial balance due or a hold of any kind on their record. Course grades for
                                those students who have not completed their financial requirements until the end of the final
                                exam week will not be entered. If a student's account remains delinquent, BAU reserves the
                                right to terminate enrollment. Additionally, they will not be cleared to receive their official
                                transcripts or completion diplomas.
                                Failure to meet financial obligations to BAU will result in other collection procedures, which
                                include account referral to credit reporting bureaus, private collection agencies, DC Office of
                                Tax and Revenue, and Office of Attorney General. Past-due accounts are subject to
                                garnishments, liens and judgments, and the withholding of money from tax refunds. In addition
                                to late fees and interest, delinquent accounts will be assessed additional collection costs up to
                                thirty percent of the past due balance, reasonable attorney fees, and other administrative costs.
                                Once an account is referred to a collection agency, payment must be made to the agency, not
                                BAU.
                        </p>
                <ul>
                    <li>
                        <strong>In Late Fee it should say:</strong> : Failure to make any tuition[AE3.1] payments on or before the module start date may result in an <strong>$80 late fee.</strong> The late fee will apply only to the tuition. Other fees (for example, activity fee, materials fee etc.) will be deducted before applying payment for tuition.
                    </li>
                    <li>
                        <strong>Return Check Fee:</strong> A <strong>$35 fee</strong> will be charged for each unpaid check returned by the bank.
                    </li>
                    <li>
                        <strong>Exceptional Cases:</strong> In the documented event of prolonged illness, accident, or death in the immediate family (parents, siblings, children, or spouse) or other exceptional circumstances that make it impractical to complete the program,
                        BAU will work toward a settlement that is reasonable and fair to both parties.
                    </li>
                </ul>

                        <div style="margin: 20px 0;">
                            <table style="width: 100%; border-collapse: collapse;">
                                <tbody>
                                    <tr>
                                        <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                            I read and confirm that I understand the information in Section F.
                                        </td>
                                        <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                            <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4>F-1 RESPONSIBILITIES (FOR F-1 STUDENTS ONLY)</h4>
                        <p><strong>Understanding the terms and conditions of your F-1 nonimmigrant status</strong></p>
                        <p>To provide the DSO the timely information needed to maintain your SEVIS record, please:</p>

                        <ol>
                            <li>Enroll in a full course of study at the beginning of every session (excluding authorized break periods).</li>
                            <li>Notify if you intend to take an authorized vacation within the US.</li>
                            <li>Report US address, email address, and phone number changes within 10 days of the change (immigration requirement).</li>
                            <li>Report on any change in sources of financial support.</li>
                            <li>Notify prior traveling outside the US. If you go to your home country, you must contact the school at least 15 days before returning to the US.</li>
                            <li>Notify upon applying for change/adjustment of status including your dependents.</li>
                            <li>Request a timely extension (30 days before the expiration date of your I-20 Form) when you need more time to complete your program.</li>
                            <li>Comply with attendance and academic policies.</li>
                            <li>Do not work without authorization.</li>
                            <li>Do not drop a class without getting approval from a DSO.</li>
                            <li>Timely notify Admissions if you intend to transfer.</li>
                        </ol>
                <div style="margin-top: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I have read, understood, and agree to comply with the F1 Student Responsibilities mentioned above.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div style="margin-bottom: 20px;">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">G. OTHER AGREEMENTS/UNDERSTANDINGS</h4>
                <div>
                    <p>
                        <strong>1. ACADEMIC CATALOG & STUDENT HANDBOOK:</strong>
                        The Academic Catalog and
                        Mentora ESL Program Student Handbook contain a description of certain policies,
                        procedures, and other information about BAU and the Mentora College ESL Program.
                        BAU reserves the right to change any provision of the catalog at any time. The current
                        catalog is available online and can be accessed at the following website addresses:
                        <a href="https://bau.edu/mentora-esl/mentora-academic-calendar/" target="_blank">Mentora Handbook</a> and <a href="https://bau.edu/academic-catalog/" target="_blank">BAU Catalog</a>.
                        Students are expected to read and be familiar with
                        the information contained in the most currently published catalog.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>2. COMPLIANCE WITH POLICIES, PROCEDURES, AND STANDARDS:</strong>
                        BAU's policies,
                        procedures, and standards are published on the website, located at
                        <a
                            href="https://bau.edu/explore-bau/public-disclosure-policies/all-bau-policies/"
                            target="_blank"
                        >https://bau.edu/explore-bau/public-disclosure-policies/all-bau-policies/</a>.
                        Students are
                        expected to know and must comply with and adhere to all applicable policies,
                        procedures, and standards. Students must also comply with any requirements specified
                        in the student's official admission letter for the Program. You may be suspended,
                        administratively separated, or expelled if you violate any of BAU's policies, rules, or
                        regulations, including attendance requirements, which may result in the revocation of
                        your immigration status. BAU reserves the right to make changes to policies. When
                        doing so, BAU makes announcements to students via email, website updates, and/or
                        posters on the campus. It is the responsibility of the students to check their emails, the
                        website, and the Academic Catalog.
                    </p>
                </div>
                <div>
                    <p>
                        <strong>H. PLAGIARISM:</strong>
                        Mentora College holds its students to high standards of academic honesty. Students
                        are expected to submit original work using their own ideas and words. Examples of
                        plagiarism or cheating include, but are not limited to:
                        <br>• Cutting and pasting an internet source
                        <br>• No in-text citations
                        <br>• No bibliography provided
                        <br>• Copying another student's work
                        <br>• Communicating answers during exams/ quizzes
                        <br>• Re-using your own or another student's work from a previous class
                        <br>• Using AI programs like ChatGPT, perplexity, etc.
                        <br><br>
                        <strong>1st Offense:</strong> If cheating, the student will receive up to 2 verbal warnings by the
                        teacher before they are removed from the class. Students will receive 0% on
                        their exam/quiz.
                        <br>
                        If plagiarism, the student may be given another chance to do the assignment
                        under the supervision of the teacher. The resubmission may be scored at a
                        maximum grade of 50%
                        <br><br>
                        <strong>2nd Offense:</strong> The student will receive a zero (0) and a warning letter for
                        Behavior Performance. The student will be placed on Behavior probation.
                        <br><br>
                        <strong>3rd Offense:</strong> The student will receive a zero (0) and face expulsion and/or
                        termination of the student's I-20 Form.
                        <br><br>
                        Teachers and the Academic team will properly document all offenses 1-3.
                        Teachers will be responsible for writing an incident report and the Academic
                        team will follow up with the warning or probation letters prepared.
                        Plagiarism and Cheating are NOT tolerated at Mentora College, and any cases
                        will be handled swiftly and seriously.
                        <br><br>
                        I read and confirm that I understand the information in Section H.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>I. ACADEMIC CALENDAR:</strong>
                        Students should familiarize themselves with the Mentora
                        College ESL Program calendar for holidays and vacations published on the website at
                        <a href="https://bau.edu/mentora-esl/mentora-academic-calendar/" target="_blank"> https://bau.edu/mentora-esl/mentora-academic-calendar</a>.
                        Classes will not be held on designated school
                        vacations and may be canceled on public holidays. BAU does not provide refunds for
                        classes not offered due to planned or unplanned school closures.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>J. IMPLIED CONSENT:</strong>
                        You acknowledge and agree that BAU or its representatives,
                        affiliates, successors, and related companies may photograph, video or otherwise record
                        you and/or other students. If you do not wish to have your photograph or video taken, you
                        must advise BAU in writing and state, at the time of the photography or recording, your
                        desire not to participate. Unless you have provided us with notice regarding your desire
                        not to participate, you hereby irrevocably grant BAU and its assigns, licensees,
                        successors in interest, legal representatives, employees, consultants and agents
                        (collectively, the “Program Entities”) the irrevocable and unrestricted right to copy, publicly
                        display, distribute, modify, create derivative works of and otherwise use your name,
                        image, voice and likeness and any photograph, video or audio recording in which you
                        appear (collectively, the “Images”). You acknowledge and agree that you have no right,
                        title or interest in or to any Images, and that the Program Entities own all right, title and
                        interest in and to all Images. You hereby waive any right to inspect or approve any
                        Images. You hereby waive all rights and release and discharge the Program Entities from
                        and shall neither sue nor bring any proceeding against the Program Entities for, any claim,
                        demand or cause of action based upon, arising from or related to the Program Entities use
                        or exploitation of the Images (or the use of your name, image, voice or likeness in
                        connection therewith), including without limitation, claims for libel or invasion of right to
                        privacy, publicity or personality. You can always visit  <a href="https://bau.edu/explore-bau/public-disclosure-policies/communication-policies-and-procedures/">BAU Communication Policies</a> to learn more about the specific settings where implied consent is applied.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>K. COMPLAINTS:</strong>
                        A student or any member of the public may file a complaint about this
                        institution on issues that cannot be resolved by direct negotiation with the school in
                        accordance with its written grievance policy with the Higher Education Licensure
                        Commission (HELC) at 1050 First Street NE Washington, DC 20002, (202) 727-6436.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>L. LEGAL:</strong>
                        The law, including the statutes of limitation, of the District of Columbia will govern
                        this Agreement, the interpretation and enforcement of its terms and any claim or cause of
                        action (in law or equity), controversy or dispute arising out of or related to it or its
                        negotiation, execution or performance, whether based on contract, tort, statutory or other
                        law, in each case without giving effect to any conflicts-of-law or other principle requiring
                        the application of the law of any other jurisdiction. Each of the parties hereto hereby
                        irrevocably and unconditionally consents to submit to the sole and exclusive jurisdiction of
                        the courts of the District of Columbia and of the United States of America located in
                        Washington, D.C. (the “Washington, D.C. Courts”) for any litigation among the parties
                        hereto arising out of or relating to this Agreement, or the negotiation, validity or
                        performance of this Agreement, waives any objection to the laying of venue of any such
                        litigation in the Washington, D.C. Courts and agrees not to plead or claim in any
                        Washington, D.C. Court that such litigation brought therein has been brought in any
                        inconvenient forum or that there are indispensable parties to such litigation that are not
                        subject to the jurisdiction of the Washington, D.C. Courts.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>M. COPY OF THE ENROLLMENT AGREEMENT:</strong>
                        A copy of this Contract will be emailed to
                        the student upon signing and will be accessible on the student’s MyBAU account.
                    </p>
                </div>

                <div style="margin: 20px 0;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I read and confirm that I understand the information in Section G.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Financial Penalties, Part III -->
            <div style="margin-bottom: 20px;">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">FINAL ACKNOWLEDGEMENT</h4>
                <div style="margin-bottom: 15px; font-size: 14px;">
                    I acknowledge and agree that the terms and conditions of this Enrollment Agreement and the Student Handbook are not subject to amendment or modification by spoken agreement. I further acknowledge and agree that no spoken statements have been made to me that are contrary to what is contained in this Enrollment Agreement or the Student Handbook.
                    My signature below certifies that I have read, understand, and agree to comply with all terms, conditions, policies, rules, and procedures contained in this Enrollment Agreement and the Student Handbook, including any updates or revisions made in accordance with institutional policy.
                    understand that the Student Handbook is included in this Enrollment Agreement and forms an important part of this contract. This Enrollment Agreement is legally binding when signed by me and accepted by Bay Atlantic University, Mentora College ESL Program.

                </div>
                <h4 class="mb-3 fs-6 fs-md-5 fw-bold">CONTRACT ACCEPTANCE</h4>
                <div class="mb-3 fs-6 fs-md-5">
                    I, the undersigned, have read and understood this agreement and agree that it, together with the Student Handbook, supersedes all prior or existing verbal or written agreements. This agreement may not be modified/changed except by written agreement signed by both the student and the School Official.
                    I also understand that if I default on this agreement, I will be responsible for paying any collection fees or attorney fees assessed by Bay Atlantic University (BAU).
                    By clicking the box below, I hereby affix my electronic signature, indicating my intent to be legally bound by the terms of this Enrollment Agreement and the Student Handbook. My signature below signifies that I have read, understood, and acknowledged all aspects of this agreement, and I have recognized my legal responsibilities under this contract.
                </div>
            </div>

          <div>
            <div><strong>{{studentData.name + ' '+studentData.surname}}</strong></div>
            <div><strong>Date: </strong>{{currentDate}}</div>
          </div>

            <!-- Submit Button -->


        </div>
        <div style="width: 100%; margin-top: 3rem;">
            <div style="margin-bottom: 1.5rem; display: flex; justify-content: center;">
                <LoadingButton
                    :loading="loading"
                    :text="$t('submit')"
                    @click="changeToHtml()"/>
            </div>
        </div>
    </div>
</template>
<script>
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import {mapGetters} from "vuex";
import moment from "moment/moment";
import LoadingButton from "@/components/elements/LoadingButton.vue";


export default {
    components: {LoadingButton},
    data() {
        return {
            registrationForm: {},
            data:[],
            scholarshipData:[],
            disabled:false,
            loading:false,
        }
    },
    computed: {
        ...mapGetters({
            studentData: "enrollmentAgreementForm/formData"
        }),
        currentDate(){
            return moment().format("MMMM Do YYYY")
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getBase64Image(img) {
            return new Promise((resolve, reject) => {
                const image = new Image();
                image.crossOrigin = 'Anonymous';
                image.src = img;
                image.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0);
                    const dataURL = canvas.toDataURL('image/png');
                    resolve(dataURL);
                };
                image.onerror = (error) => {
                    reject(error);
                };
            })
        },
        async changeToHtml() {
            this.loading = true;
            try {
                const printPdf = this.$refs.printPdf;
                const logoImage = this.$refs.logoImage;
                const logoBase64 = await this.getBase64Image(logoImage.src);
                logoImage.src = logoBase64;
                const htmlString = printPdf.outerHTML;
                const base64String = btoa(unescape(encodeURIComponent(htmlString)));
                await this.sendToBackend(base64String);
            } catch (error) {
                console.error('Error in changeToHtml:', error);
            } finally {
                this.loading = false;
            }
        },
        async getData() {
            let user = await JSON.parse(localStorage.getItem('user'));
            const response = await EnrollmentAgreementForm.getStudentInformation(user.id)
            let data = response.data.data
            const firstModuleDate = data?.first_module_date;
            let isAugust24 = ['2026-08-24', '2026-09-21', '2026-10-19'].includes(firstModuleDate) || ['08/24/2026', '09/21/2026', '10/19/2026'].includes(firstModuleDate)
            let tuitionFee=data?.tuition_fee;
            if(!isAugust24 && moment().format('YYYY-MM-DD')<'2026-11-01' && (firstModuleDate == null || String(firstModuleDate).trim() === '')){
              isAugust24 = true
              tuitionFee=0;
            }
            const moduleDate = moment(data?.active_module_start_date, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
            const moduleTitle = isAugust24 ? 'August 24th' : moduleDate.isValid() ? moduleDate.locale('en').format('MMMM Do') : '';
            this.data.push(
                  {
                    key: 'Admission Confirmation Deposit',
                    value: `$${data?.admission_confirmation_deposit?data?.admission_confirmation_deposit:0} – Non Refundable (but credited towards tuition).`,
                },
                {
                    key: 'Tuition Deposit',
                    value: `$${data?.tuition_deposit?data.tuition_deposit:0} – Non Refundable (but credited towards tuition).`,
                },
               {
                    key: moduleTitle ? `${moduleTitle} Module Tuition` : 'Tuition',
                    value: `$${tuitionFee? parseFloat(tuitionFee) : 0}`,
                },
                ...(isAugust24 ? [{ key: 'Regular Tuition Rate', value: '$550' }] : []),
               {
                 key: 'MANDATORY FEES',
                 value: `Materials: $${data.esl_course_materials_fee ?? 0}<br>Student Activities and Services Fee: $${data.mentora_services_fee}<br>Student ID Fee: $22 (only if this is your first Module at BAU-Mentora)<br>`,
               },
                {
                    key: 'OTHER FEES MAY APPLY',
                    value: `For example, requests by students for official university documents (e.g., requests for transcripts, enrollment verifications and academic records) may require payment of the relevant fee(s). Information about the above-mentioned university fees and other fees can be found on  <a href="https://bau.edu/mentora-esl/mentora-tuition-fees/">Bay Atlantic University’s website</a>.`
                }

            )
            const rows = [
                {
                    key: 'Type of Scholarship/Discount/Award Applied During Module:',
                    value: isAugust24
                        ? 'First Module Tuition Free; $400 Tuition per Module for the Following 11 Modules'
                        : data.scholarship_name ?? '',
                },
                {
                    key: 'Start Date of Module and End Date of Module which Scholarship/Discount/Award Applied:',
                    value: isAugust24
                        ? 'New Students with an August 24, 2026 Start Date: August 24, 2026 - July 19, 2027 module\nNew Students with a September 21, 2026 Start Date: September 21, 2026 - August 16, 2027 module\nNew Students with a October 19, 2026 Start Date: October 19, 2026 - September 13, 2027 module'
                        : Number(data.total_discount_amount) > 0
                            ? [data.active_module_start_date, data.active_module_end_date].filter(Boolean).join(' - ')
                            : '',
                },
                {
                    key: 'Amount That Will Be Applied This Module:',
                    value: isAugust24
                        ? 'First Module: Tuition Free + mandatory fee.\nFollowing 11 Modules: Tuition is $400 per module + mandatory fees.'
                        : this.currencyFormat(data.discount_amount ?? 0),
                },
                {
                    key: 'Additional Awards Given for This Module:',
                    value: isAugust24 ? '$0' : this.currencyFormat(data.additional_awards_amount ?? 0),
                },
            ];
            if (isAugust24 || data.promotion_code) {
                rows.push({
                    key: 'Description',
                    value: isAugust24
                        ? 'First module tuition fee + mandatory fees, followed by $400 tuition + mandatory fees per module for the next 11 modules. Starting from the 13th module, students will pay the current regular tuition rate + mandatory fees per module. <i>This scholarship/tuition assistance/award is conditional upon the student completing a minimum of twelve (12) enrollment modules at Mentora College. By accepting this scholarship/discount, the student acknowledges and agrees to maintain enrollment for the full 12-module promotional period.</i>'
                        : data.promotion_code,
                });
            }
            this.scholarshipData = rows;
            this.registrationForm = {
                ...this.studentData,
                registration_date: data.registration_date,
                program_name: data.program_name,
                registration_semester_academic_year: data.registration_semester_academic_year,
                anticipated_end_date: data.anticipated_end_date,
                registration_type_text: data.registration_type_text,
                total_credit_required_for_graduation: data.total_credit_required_for_graduation,
                tuition_per_credit: data.tuition_per_credit,
                total_discount_per_credit: data.discount_per_credit*data.total_credit_required_for_graduation
            }
        },
        async sendToBackend(base64String) {
            const config = {
                // html: base64String,
                contact_address:this.studentData.contact_address,
                contact_state_id:this.studentData.contact_state_id,
                contact_city_id:this.studentData.contact_city_id,
                contact_zip_code:this.studentData.contact_zip_code,
                apartment:this.studentData.apartment,
                address_country_id:this.studentData.address_country_id,
                address:this.studentData.address,
                verification_code:this.studentData.verification_code,
                personal_email:this.studentData.personal_email,
                mobile_tel:this.studentData.mobile_tel,
                mobile_tel_country_code:this.studentData.mobile_tel_country_code,
                home_tel:this.studentData.home_tel,
                home_tel_country_code:this.studentData.home_tel_country_code,
                emergency_person_phone_country_code:this.studentData.emergency_person_phone_country_code,
                emergency_person_relation:this.studentData.emergency_person_relation,
                emergency_person_name:this.studentData.emergency_person_name,
                emergency_person_phone:this.studentData.emergency_person_phone,
                birthdate:this.studentData.birthdate,
            }
          try {
            const response = await EnrollmentAgreementForm.sendForm(config);
            if (response.data.success===true) {
              this.$toast.success(this.$t('form_submission_successful'))
              this.$emit('sendSuccessForm', true)
              this.clearForm()
              this.$router.push('/dashboard');
            } else {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.clearForm()
            }
          } catch (error) {
              if (error.data.message==="SMS_CODE_ERROR"){
                  this.$toast.error(this.$t('api.' + error.data.message));
                  this.$emit('errorSmsCode',true)
              }else{
                  this.$toast.error(this.$t('api.' + error.data.message));
              }
          }
        },
        async clearForm() {
            await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
        },

    },


};
</script>

<style scoped>
.info-row {
    display: flex !important;
    flex-direction: row !important;
    margin-bottom: 8px;
    align-items: flex-start;
    page-break-inside: avoid;
}

.info-label {
    font-weight: bold;
    width: 150px !important;
    min-width: 150px !important;
    margin-right: 10px !important;
    color: #555;
    flex-shrink: 0 !important;
    display: inline-block !important;
    vertical-align: top;
}


.fee-row {
    display: flex !important;
    flex-direction: row !important;
    margin-bottom: 8px;
    align-items: flex-start;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
    page-break-inside: avoid;
}

.fee-label {
    font-weight: bold;
    width: 200px !important;
    min-width: 200px !important;
    margin-right: 10px !important;
    color: #555;
    flex-shrink: 0 !important;
    display: inline-block !important;
    vertical-align: top;
}

.fee-value {
    flex: 1 !important;
    color: #333;
    display: inline-block !important;
    vertical-align: top;
    word-wrap: break-word;
}

/* Print styles for PDF generation */
@media print {
    .info-row {
        display: flex !important;
        flex-direction: row !important;
        margin-bottom: 8px;
        align-items: flex-start;
        page-break-inside: avoid;
    }

    .info-label {
        font-weight: bold;
        width: 150px !important;
        margin-right: 10px !important;
        color: #555;
        flex-shrink: 0 !important;
        display: inline-block !important;
    }



    .fee-row {
        display: flex !important;
        flex-direction: row !important;
        margin-bottom: 8px;
        align-items: flex-start;
        border-bottom: 1px solid #eee;
        padding-bottom: 8px;
        page-break-inside: avoid;
    }

    .fee-label {
        font-weight: bold;
        width: 200px !important;
        margin-right: 10px !important;
        color: #555;
        flex-shrink: 0 !important;
        display: inline-block !important;
    }

    .fee-value {
        flex: 1 !important;
        color: #333;
        display: inline-block !important;
    }
}
</style>

